import { ItemStateModel } from "./item-state.model";

export class CustodianState extends ItemStateModel {
    custodians: CustodianDetail[];
    caseCustodianCount: number;
}

export class CustodianDetail {
    name: string;
    docCount: number;
}
